<template>
  <div class="app-wrapper" :class="classObj">
    <Sidebar class="sidebar-container" />
    <div class="main-container">
      <Navbar />
      <AppMain />

      <!-- 引导按钮 start -->
      <div v-if="isRouteDirectVisible">
        <div v-for="(item, index) in routes.children" :key="item.name">
          <div
            class="route-direct"
            v-if="!item.hidden"
            @click="HandleRouteDirectTo(item)"
            :style="`animation-delay: ${index * 0.2}s`"
          >
            {{ item.meta.title }}
          </div>
        </div>
      </div>
      <!-- 引导按钮 end -->

      <!-- 变回原本身份 start -->
      <el-button
        v-if="loginToken"
        @click="HandleTransformBack()"
        :loading="submitLoading"
        icon="el-icon-refresh"
        size="small"
        slot="reference"
        class="transform-huerotate transform-back-btn"
      >
        变回原本身份

        <!-- 若在变身中，提示该用户密码是否逾期或将要逾期 -->
        <el-tag size="mini" type="danger" v-if="userInfo.loginExpiredTime !== 0"
          ><span style="font-weight: 600">{{ userInfo.username }}</span> 密码{{
            userInfo.loginExpiredTime === -1
              ? "已逾期"
              : `将于 ${userInfo.loginExpiredTime} 天后逾期`
          }}</el-tag
        >
      </el-button>
      <!-- 变回原本身份 end -->
    </div>

    <!-- 强制改密码 -->
    <PasswordDialog
      v-if="userInfo && userInfo.loginExpiredTime !== 0"
      :password-dialog-obj.sync="passwordDialogObj"
    />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { setToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import PasswordDialog from "@/views/profile/my/PasswordDialog";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      routes: [],
      to: null,
      isRouteDirectVisible: false,
      loginToken: localStorage.getItem("loginToken") || null, // 变身状态
      submitLoading: false,
      passwordDialogObj: {}, // 修改密码 obj
    };
  },
  components: {
    PasswordDialog,
    Navbar,
    Sidebar,
    AppMain,
  },
  mixins: [ResizeMixin],
  watch: {
    // 监控 route 变化
    $route(to) {
      this.HandleRouteDirectFind(to);
    },
  },
  created() {
    // 创见 Layout 元件后先找一遍 route
    this.HandleRouteDirectFind(this.$route);

    // 若非在变身中，
    if (!this.loginToken) {
      if (this.userInfo.loginExpiredTime === -1) {
        // 且需要强制改密码，开启修密码弹框
        Cookies.remove("hintPasswordChangeLater");
        this.passwordDialogObj = { visible: true, force: true };
      } else if (
        this.userInfo.loginExpiredTime === 0 &&
        Cookies.get("hintPasswordChangeLater") === "1"
      ) {
        // 且已经完成密码修改，清除 cookie
        Cookies.remove("hintPasswordChangeLater");
      } else if (
        this.userInfo.loginExpiredTime > 0 &&
        Cookies.get("hintPasswordChangeLater") !== "1"
      ) {
        // 且密码期限快逾期，出现提示
        this.hintPasswordChange();
      }
    }
  },
  computed: {
    ...mapGetters(["routers", "userInfo"]),
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    // 密码即将逾期友善提示
    hintPasswordChange() {
      this.$confirm(
        `是否要立即修改密码？`,
        `你的密码将于 ${this.userInfo.loginExpiredTime} 天后逾期！`,
        {
          confirmButtonText: "立即修改",
          cancelButtonText: "不再提示",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.passwordDialogObj = {
            visible: true,
          };
        })
        .catch(() => {
          // 不再出现提示，直到 userInfo.loginExpiredTime > 0 时
          Cookies.set("hintPasswordChangeLater", "1");
        });
    },
    HandleTransformBack() {
      this.submitLoading = true;
      this.$notify.success("正在变回原本身份，请稍后...");
      // 将原本存在 localStorage 的 loginToken 存到 cookie
      setToken(this.loginToken);
      // 移除 localStorage 的 loginToken 字段
      localStorage.removeItem("loginToken");
      // 返回用户管理 全部用户
      setTimeout(() => {
        this.submitLoading = false;
        location.href = "/#/user/all";
        location.reload(); // 返回时必须重刷页面
      }, 500);
    },
    HandleRouteDirectFind(to) {
      // 如果找到了符合的 path 丢到 data 中
      this.routers.forEach((res) => {
        if (to.path === res.path) {
          this.routes = res;
          this.to = to.path;
        }
      });
      // 如果 route 长度大于 2 或 path 为 home 则不展示引导按钮
      this.isRouteDirectVisible =
        location.hash.split("/").length > 2 || to.path === "/home"
          ? false
          : true;
    },
    HandleRouteDirectTo(item) {
      this.$router.push({ path: `${this.to}/${item.path}` });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.transform-back-btn {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 10;
}

.route-direct {
  padding: 12px;
  margin: 12px auto;
  width: 98%;
  box-sizing: border-box;
  border: 1px #eee solid;
  font-size: 17px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  animation: slidein 0.3s ease 1 both;
  &:hover {
    color: #409eff;
    background: #fbfbfb;
  }
}

@keyframes slidein {
  0%,
  20% {
    transform: translateX(-10rem);
    opacity: 0;
  }
  90% {
    transform: translate(2rem);
    opacity: 0.5;
  }
  100% {
    transform: translate(0);
    opacity: 1;
  }
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.app-wrapper:before {
  content: " ";
  display: block;
  position: fixed;
  right: -20%;
  bottom: -20%;
  width: 80%;
  height: 80%;
  opacity: 0;
  z-index: -1;
  background-image: url("~@/assets/images/dragon.png");
  background-repeat: no-repeat;
  background-position: 110% 110%;
  background-size: contain;
  animation: dragon-fly 30s infinite;
}

@keyframes dragon-fly {
  0% {
    right: -20%;
    bottom: -20%;
    opacity: 0;
  }
  70% {
    right: -10%;
    bottom: -10%;
    opacity: 0.03;
  }
  100% {
    right: 0%;
    bottom: 0%;
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/Layout.vue